import { render, staticRenderFns } from "./md.vue?vue&type=template&id=2fe39acd&scoped=true&"
import script from "./md.vue?vue&type=script&lang=js&"
export * from "./md.vue?vue&type=script&lang=js&"
import style0 from "./md.vue?vue&type=style&index=0&id=2fe39acd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe39acd",
  null
  
)

export default component.exports